import classNames from 'classnames'
import styled from 'styled-components'
import {palette} from 'styled-tools'
import {media} from 'styled-bootstrap-grid'
import {RiNotificationLine} from '@remixicon/react'

import {H2, P} from '@festi/common/components/typography'
import {styledTheme} from '@festi/common/themes'

import {LoadingBubble} from './AudkenniLoader'

const Box = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;
  height: 0;
  opacity: 0;
  border-radius: 12px;
  background-color: ${palette('ui4Solid')};
  transition: all 400ms ease-out;
  overflow: hidden;

  &.show {
    height: 100%;
    padding: 16px;
    opacity: 1;
  }

  ${media.sm`
    align-items: center;

    &.show {
      padding: 24px;
    }
  `}

  &.hasError {
    height: 100%;
    padding: 24px;
    opacity: 1;
    background-color: ${palette('pink40')};
  }
`

const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 64px;
  height: 64px;
  border-radius: 8px;
  background-color: ${palette('blue')};
  transition: background-color 400ms ease-out;

  ${media.sm`
    max-width: 88px;
    height: 88px;
  `}

  &.hasError {
    background-color: ${palette('error')};
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 8px;

  ${media.sm`
    flex-direction: row;
    align-items: center;
  `}
`

const Loading = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`

interface Props {
  loading?: boolean
  errorMsg?: string
  securityCode?: string
}

export default function Audkenni({
  securityCode,
  errorMsg,
  loading = false,
}: Props): JSX.Element {
  const hasError = !!errorMsg

  return (
    <Box className={classNames({show: loading || hasError, hasError})}>
      <IconBox className={classNames({hasError})}>
        <RiNotificationLine color="white" />
      </IconBox>

      <Wrapper>
        {errorMsg ? (
          <div>
            <P bold>Villa hefur átt sér stað</P>
            <P>{errorMsg}</P>
          </div>
        ) : (
          <>
            {securityCode ? (
              <div>
                <P style={{color: styledTheme.palette.ui80}}>
                  Auðkenningarnúmer
                </P>
                <H2>{securityCode}</H2>
              </div>
            ) : (
              <Loading>
                <LoadingBubble loading />
                <LoadingBubble loading />
                <LoadingBubble loading />
              </Loading>
            )}

            <div>
              <P bold>Auðkenni sent, kíktu á síma.</P>
            </div>
          </>
        )}
      </Wrapper>
    </Box>
  )
}
